<template>
  <div>
    <Placeholder v-if="loading" />
    <div id="doc-content" v-else v-html="content">
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Placeholder from '../components/placeholder';

export default {
  name: 'DocPage',
  props: [],
  components: {
    Placeholder,
  },
  data: function () {
    return {
      loading: false,
      content: '',
    };
  },
  computed: {
  },
  methods: {
    async load_content(id) {
      var url = 'https://docs.hondcloud.com/wp-json/wp/v2/pages/' + id;
      var r = await axios.get(url);
      this.content = r.data.content.rendered;
    }
  },
  mounted() {
    this.load_content(this.$route.params.id);
  },
}
</script>

<style>
h2 {
  font-size: xx-large;
}
h3 {
  font-size: x-large;
}
h4 {
  font-size: large;
}
#doc-content {
  max-width: 600px;
  margin-left: auto !important;
  margin-right: auto !important;
}
time {
  margin-left: 1rem;
}
ul.wp-block-latest-posts > li > a {
  font-size: large;
  margin-top: 10px !important;
}
</style>

